export default {"src":"/_next/static/media/socialMedia_Free R5_V2.504782b3.gif","height":300,"width":300};